var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"change-password-view"},[_c('div',{staticClass:"change-password-view__form"},[_c('h4',[_vm._v(" Veuillez saisir votre nouveau mot de passe ")]),_c('dc-change-password-form')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }